import { Button } from 'antd';

import { trackButtonClick } from '../../analytics/mixpanel';
import DownloadOutlined from '../../assets/docchat/DownloadOutlined';
import styles from './LargeResponseDownload.module.scss';
import { useDownloadResponse } from './useDownloadResponse';
import { useRecordFileName } from './useRecordFileName';

const LargeResponseDownload = ({ data }) => {
  const { downloadResponse, downloading } = useDownloadResponse();
  const recordFileName = useRecordFileName();

  const handleDownload = () => {
    trackButtonClick({ type: 'Download large chat response' });
    const prefix = recordFileName ? `${recordFileName}-` : '';
    downloadResponse({
      downloadUrl: data.download_url,
      fileName: `${prefix}chat-response-${data.query_response_id}.docx`,
    });
  };

  return (
    <div className={styles.container}>
      <p className={styles.heading}>This response is too long to show here.</p>
      <p className={styles.description}>Download it to read the full response.</p>
      <Button
        className={styles.downloadButton}
        type='link'
        icon={<DownloadOutlined />}
        onClick={handleDownload}
        loading={downloading}
        disabled={downloading || !data.download_url}
      >
        Download response
      </Button>
    </div>
  );
};

export default LargeResponseDownload;
